export default __webpack_public_path__ + "static/media/ST2-C_150_F.10807016.png";